import styled from 'styled-components';

export const Icon = styled.button`
  border: none;
  background: transparent;

  color: ${({ variant }) =>
    variant === "pink"
      ? "var(--pink-contentoh)"
      : variant === "white"
      ? "var(--white-contentoh)"
      : variant === "gray"
      ? "var(--gray-contentoh)"
      : variant === "purple"
      ? "var(--purple)"
      : variant === "yellow"
      ? "var(--yellow)"
      : variant === "red"
      ? "var(--red-contentoh)"
      : variant === "blue-light"
      ? "var(--gray-contentoh)"
      : variant === "green"
      ? "var(--green)"
      : "inherit"};


  &:hover {
   
  }



  .filled.material-symbols-outlined {
    font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 0, "opsz" 24;
  }
`;